import Modal from "../Modal/Modal";
import { Container, MainButton } from "./AdditionalVolanteModalStyles";

function AdditionalInfoReviewingModal(props) {
  const { toggleModal } = props;

  return (
    <Modal onOutsideClick={() => toggleModal()}>
      <Container width="37.5rem">
        <h1>Documento en revisión</h1>
        <p>
          Este volante ya tiene un documento en revisión, puede ver el estado
          del volante en el apartado “Gestión de validaciones”
        </p>
        <MainButton onClick={() => toggleModal()}>Entendido</MainButton>
      </Container>
    </Modal>
  );
}

export default AdditionalInfoReviewingModal;
